import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable } from '@y42/angular/util';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-toggle-selection-button',
  templateUrl: './toggle-selection-button.component.html',
  styleUrls: ['./toggle-selection-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleSelectionButtonComponent {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() protected readonly toggleSelectionMode = new EventEmitter<void>();

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });
}
